import {
  getPointSeriesMaxSecs,
  normaliseTimeValuePoints,
  readArray,
  readFiniteNumber,
  toTimeValuePoints,
} from "./viewTimeSeries";

export function pickHeartDxPeakIntervals(docData) {
  return readArray(
    docData?.results?.heartdx?.data?.peak_intervals ??
      docData?.heartdx?.peak_intervals ??
      docData?.heartdx?.data?.peak_intervals,
  ).filter((value) => typeof value === "number" && Number.isFinite(value));
}

export function buildPoincareFromIntervals(intervals) {
  if (!Array.isArray(intervals) || intervals.length < 2) {
    return { x: [], y: [] };
  }

  const x = [];
  const y = [];

  for (let index = 0; index < intervals.length - 1; index += 1) {
    const current = intervals[index];
    const next = intervals[index + 1];

    if (
      typeof current === "number" &&
      Number.isFinite(current) &&
      typeof next === "number" &&
      Number.isFinite(next)
    ) {
      x.push(current);
      y.push(next);
    }
  }

  return { x, y };
}

export function pickCardiopulmonaryDetrendedSignal(docData) {
  const processed =
    docData?.["mpm-signal-processed"] ||
    docData?.mpmSignalProcessed ||
    docData?.mpm_signal_processed ||
    null;

  if (!processed) {
    return {
      points: [],
      maxSecs: 60,
    };
  }

  const values = readArray(
    processed.detrendedTrace ??
      processed.detrendedSignal ??
      processed.detrended_signal,
  );

  const times = readArray(
    processed.timesSeconds ??
      processed.resampledTimesSeconds ??
      processed.timeSeconds ??
      processed.time_seconds,
  );

  const samplingRateHz =
    readFiniteNumber(processed.samplingRateHz) ??
    readFiniteNumber(processed.sampling_rate_hz) ??
    30;

  const points = toTimeValuePoints(values, times, samplingRateHz);
  const normalisedPoints = normaliseTimeValuePoints(points);

  return {
    points: normalisedPoints,
    maxSecs: normalisedPoints.length
      ? getPointSeriesMaxSecs(normalisedPoints, 60)
      : 60,
  };
}

export function hasFirestoreFlowLoops(docData) {
  return Array.isArray(docData?.results?.mpm?.flow_loop?.breaths);
}
